<template>
  <header class="header-v2">
    <div class="header-container">
      <!-- Logo à esquerda -->
      <div class="header-left">
        <router-link to="/admin" class="logo-link">        
          <img src="../../assets/images/logo.png" alt="Logo" class="logo-image" />          
        </router-link>
      </div>

      <!-- Seletor de empresa no centro -->
      <div class="header-center">
        <div class="company-selector">
          <div class="dropdown">
            <button 
              class="company-btn" 
              type="button" 
              data-bs-toggle="dropdown" 
              aria-expanded="false"
            >
              <div class="company-info">
                <span class="company-label">Empresa:</span>
                <span class="company-name">{{ $store.getters.user?.customer_name || 'Carregando...' }}</span>
              </div>
              <font-awesome-icon :icon="['fa', 'chevron-down']" class="dropdown-arrow" />
            </button>
            <ul class="dropdown-menu">
              <li v-for="(userCompany, index) in $store.getters.userCompanies" :key="index">
                <a class="dropdown-item" href="#" @click="changeCompany(userCompany)">
                  <font-awesome-icon :icon="['fa', 'building']" class="company-icon" />
                  {{ userCompany.customer.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Ações à direita -->
      <div class="header-right">
        <!-- Badge de manutenção -->
        <span v-if="$store.state.maintenance" class="maintenance-badge">
          MODO MANUTENÇÃO ATIVO
        </span>

        <!-- Notificações -->
        <div v-if="$store.getters.user?.access_invoices == 1" class="notification-wrapper desktop-only">
          <button class="notification-btn" @click="toggleNotifications">
            <font-awesome-icon :icon="['fa', 'bell']" />
            <div v-if="pendingInvoicesTotal > 0" class="notification-badge">
              {{ pendingInvoicesTotal }}
            </div>
          </button>
          
          <!-- Dropdown de notificações -->
          <div v-if="showNotifications" class="notifications-dropdown">
            <div class="notifications-header">
              <h6>Notificações</h6>
            </div>
            <div class="notifications-content">
              <div v-if="pendingInvoices && pendingInvoices.length > 0" class="notifications-list">
                <div class="notification-item" @click="showInvoicesModal">
                  <div class="notification-icon">
                    <font-awesome-icon :icon="['fa', 'exclamation-triangle']" />
                  </div>
                  <div class="notification-details">
                    <h6>Débitos em Aberto</h6>
                    <span>{{ pendingInvoicesTotal }} pendente{{ pendingInvoicesTotal > 1 ? 's' : '' }}</span>
                  </div>
                  <font-awesome-icon :icon="['fa', 'chevron-right']" class="notification-arrow" />
                </div>
              </div>
              <div v-else class="no-notifications">
                <font-awesome-icon :icon="['fa', 'bell']" />
                <p>Não há notificações</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Logout -->
        <button class="action-btn logout-btn" @click="logout" title="Logout">
          <font-awesome-icon :icon="['fa', 'power-off']" />
        </button>

        <!-- Perfil do usuário -->
        <router-link v-if="$store.getters.user" to="/admin/profile" class="profile-link">
          <img :src="$store.getters.user.photo" class="profile-avatar" alt="Profile" />
          <div class="profile-info">
            <span class="profile-name">{{ $store.getters.user.name }}</span>
          </div>
        </router-link>

        <!-- Botão mobile -->
        <button class="mobile-menu-btn" @click="toggleMobileMenu">
          <font-awesome-icon :icon="['fa', 'bars']" />
        </button>
      </div>
    </div>

    <!-- Menu Mobile -->
    <div class="mobile-menu" :class="{ 'mobile-menu-active': mobileMenuActive }">
      <div class="mobile-menu-header">
        <div class="mobile-user-info" v-if="$store.getters.user">
          <img :src="$store.getters.user.photo" class="mobile-avatar" alt="Profile" />
          <div class="mobile-user-details">
            <span class="mobile-user-name">{{ $store.getters.user.name }}</span>
            <router-link to="/admin/profile" class="mobile-profile-link" @click="closeMobileMenu">
              Ver perfil <font-awesome-icon :icon="['fa', 'angle-right']" />
            </router-link>
          </div>
        </div>
        <button class="mobile-close-btn" @click="closeMobileMenu">
          <font-awesome-icon :icon="['fa', 'times']" />
        </button>
      </div>
      
      <!-- Seletor de empresa no menu mobile -->
      <div class="mobile-company-selector" v-if="$store.getters.userCompanies && $store.getters.userCompanies.length > 0">
        <h6 class="mobile-section-title">Empresas</h6>
        <ul class="mobile-company-list">
          <li v-for="(userCompany, index) in $store.getters.userCompanies" :key="index">
            <button class="mobile-company-item" @click="changeCompanyMobile(userCompany)">
              <font-awesome-icon :icon="['fa', 'building']" class="mobile-company-icon" />
              <span>{{ userCompany.customer.name }}</span>
              <span class="mobile-active-badge" v-if="$store.getters.user?.customer_id === userCompany.customer.id">
                Ativa
              </span>
            </button>
          </li>
        </ul>
      </div>
      
      <!-- Itens do Menu Principal -->
      <div class="mobile-main-menu">
        <h6 class="mobile-section-title">Menu Principal</h6>
        <ul class="mobile-menu-list">
          <!-- Página Inicial -->
          <li>
            <router-link to="/admin" class="mobile-menu-item" @click="closeMobileMenu">
              <font-awesome-icon :icon="['fa', 'home']" class="mobile-menu-icon" />
              <span>Página Inicial</span>
            </router-link>
          </li>
          
          <!-- Contratos -->
          <li v-if="$store.getters.user?.access?.indexOf(2) > -1">
            <router-link to="/admin/contract-list" class="mobile-menu-item" @click="closeMobileMenu">
              <font-awesome-icon :icon="['fa', 'file-contract']" class="mobile-menu-icon" />
              <span>Contratos</span>
            </router-link>
          </li>
          
          <!-- Financeiro -->
          <li v-if="$store.getters.user?.access?.indexOf(3) > -1" class="mobile-menu-dropdown">
            <div class="mobile-menu-dropdown-header" @click="toggleMobileSubmenu('financeiro')">
              <font-awesome-icon :icon="['fa', 'coins']" class="mobile-menu-icon" />
              <span>Financeiro</span>
              <font-awesome-icon 
                :icon="['fa', mobileSubmenus.financeiro ? 'chevron-down' : 'chevron-right']" 
                class="mobile-dropdown-arrow" 
              />
            </div>
            <div class="mobile-submenu" v-if="mobileSubmenus.financeiro">
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(4) > -1"
                to="/admin/invoice-list" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Consulta de Títulos</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(5) > -1"
                to="/admin/financial-dash" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Dashboard Financeiro</span>
              </router-link>
            </div>
          </li>
          
          <!-- Pedidos -->
          <li v-if="$store.getters.user?.access?.indexOf(9) > -1" class="mobile-menu-dropdown">
            <div class="mobile-menu-dropdown-header" @click="toggleMobileSubmenu('pedidos')">
              <font-awesome-icon :icon="['fa', 'shopping-cart']" class="mobile-menu-icon" />
              <span>Pedidos</span>
              <font-awesome-icon 
                :icon="['fa', mobileSubmenus.pedidos ? 'chevron-down' : 'chevron-right']" 
                class="mobile-dropdown-arrow" 
              />
            </div>
            <div class="mobile-submenu" v-if="mobileSubmenus.pedidos">
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(10) > -1"
                to="/admin/order-new" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Novo Pedido</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(11) > -1"
                to="/admin/order-unbilled-list" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Pedidos a Faturar</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(12) > -1"
                to="/admin/order-list" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Pedidos em Rota</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(13) > -1"
                to="/admin/order-finished-list" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Pedidos Entregues</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(14) > -1"
                to="/admin/order-list-ni" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Pedidos Realizados</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(15) > -1"
                to="/admin/order-draft" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Pedidos em Rascunho</span>
              </router-link>
            </div>
          </li>
          
          <!-- Embalagens -->
          <li v-if="dotEnv.isAmbientaly && $store.getters.user?.access?.indexOf(19) > -1">
            <router-link to="/admin/packaging-list" class="mobile-menu-item" @click="closeMobileMenu">
              <font-awesome-icon :icon="['fa', 'box-open']" class="mobile-menu-icon" />
              <span>Embalagens</span>
            </router-link>
          </li>
          
          <!-- Documentos -->
          <li v-if="$store.getters.user?.access?.indexOf(20) > -1" class="mobile-menu-dropdown">
            <div class="mobile-menu-dropdown-header" @click="toggleMobileSubmenu('documentos')">
              <font-awesome-icon :icon="['fa', 'file-alt']" class="mobile-menu-icon" />
              <span>Documentos</span>
              <font-awesome-icon 
                :icon="['fa', mobileSubmenus.documentos ? 'chevron-down' : 'chevron-right']" 
                class="mobile-dropdown-arrow" 
              />
            </div>
            <div class="mobile-submenu" v-if="mobileSubmenus.documentos">
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(21) > -1"
                to="/admin/fds-list" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>FDS</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(22) > -1"
                to="/admin/fde-list" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Ficha de Emergência</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(29) > -1"
                to="/admin/winner-docs" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Certidões</span>
              </router-link>
            </div>
          </li>
          
          <!-- Telemetria -->
          <li v-if="$store.getters.user?.access?.indexOf(40) > -1" class="menu-item-novo">
            <router-link to="/admin/telemetry" class="mobile-menu-item" @click="closeMobileMenu">
              <font-awesome-icon :icon="['fa', 'broadcast-tower']" class="mobile-menu-icon" />
              <span>Telemetria</span>
              <span class="mobile-novo-badge">Novo</span>
            </router-link>
          </li>
          
          <!-- Administrativo -->
          <li v-if="$store.getters.user?.access?.indexOf(23) > -1" class="mobile-menu-dropdown">
            <div class="mobile-menu-dropdown-header" @click="toggleMobileSubmenu('administrativo')">
              <font-awesome-icon :icon="['fa', 'cogs']" class="mobile-menu-icon" />
              <span>Administrativo</span>
              <font-awesome-icon 
                :icon="['fa', mobileSubmenus.administrativo ? 'chevron-down' : 'chevron-right']" 
                class="mobile-dropdown-arrow" 
              />
            </div>
            <div class="mobile-submenu" v-if="mobileSubmenus.administrativo">
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(24) > -1"
                to="/admin/user-list" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Usuários</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(25) > -1"
                to="/admin/timelogs" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Tempo de Logs</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(26) > -1"
                to="/admin/logaccess" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Log de Acesso</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(27) > -1"
                to="/admin/configs" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Configurações</span>
              </router-link>
              <router-link 
                v-if="$store.getters.user?.access?.indexOf(28) > -1"
                to="/admin/reports" 
                class="mobile-submenu-item"
                @click="closeMobileMenu"
              >
                <span class="mobile-submenu-dot"></span>
                <span>Relatórios</span>
              </router-link>
            </div>
          </li>
          
          <!-- Meu Perfil (para usuários sem acesso administrativo) -->
          <li v-if="!$store.getters.user?.access?.indexOf(23) > -1">
            <router-link to="/admin/profile" class="mobile-menu-item" @click="closeMobileMenu">
              <font-awesome-icon :icon="['fa', 'user']" class="mobile-menu-icon" />
              <span>Meu Perfil</span>
            </router-link>
          </li>
        </ul>
      </div>
      
      <!-- Notificações no menu mobile -->
      <div class="mobile-notifications" v-if="$store.getters.user?.access_invoices == 1 && pendingInvoices && pendingInvoices.length > 0">
        <h6 class="mobile-section-title">Notificações</h6>
        <div class="mobile-notification-item" @click="showInvoicesModalMobile">
          <div class="mobile-notification-icon">
            <font-awesome-icon :icon="['fa', 'exclamation-triangle']" />
          </div>
          <div class="mobile-notification-details">
            <h6>Débitos em Aberto</h6>
            <span>{{ pendingInvoicesTotal }} pendente{{ pendingInvoicesTotal > 1 ? 's' : '' }}</span>
          </div>
          <font-awesome-icon :icon="['fa', 'chevron-right']" class="mobile-notification-arrow" />
        </div>
      </div>
      
      <!-- Ações do menu mobile -->
      <div class="mobile-actions">
        <button class="mobile-action-btn" @click="logout">
          <font-awesome-icon :icon="['fa', 'power-off']" class="mobile-action-icon" />
          <span>Sair do Sistema</span>
        </button>
      </div>
    </div>

    <!-- Modal de faturas pendentes -->
    <div v-if="showInvoicesModalFlag" class="" @click="closeInvoicesModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h5>
            <font-awesome-icon :icon="['fa', 'exclamation-triangle']" class="text-danger" />
            Atenção: Você tem pagamentos em aberto ({{ pendingInvoicesTotal }})
          </h5>
          <button @click="closeInvoicesModal" class="close-btn">
            <font-awesome-icon :icon="['fa', 'times']" />
          </button>
        </div>
        <div class="modal-body">
          <table class="invoices-table">
            <thead>
              <tr>
                <th>N° Nota</th>
                <th>Valor</th>
                <th>Vencimento</th>
              </tr>
            </thead>
            <tbody>
              <invoice-details 
                v-for="(invoice, index) in pendingInvoices" 
                :key="index" 
                :invoice="invoice"
              />
            </tbody>
          </table>
          <div class="modal-actions">
            <button @click="seeAllDebts" class="btn-primary">
              Veja lista completa
              <font-awesome-icon :icon="['fa', 'arrow-right']" class="btn-icon" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import InvoiceDetails from "../Invoice/Detail.vue";
import env from "../../env.js";

export default {
  name: 'Headerv2',
  components: {
    InvoiceDetails,
  },
  data() {
    return {
      showNotifications: false,
      showInvoicesModalFlag: false,
      pendingInvoices: [],
      pendingInvoicesTotal: 0,
      mobileMenuActive: false,
      mobileSubmenus: {
        financeiro: false,
        pedidos: false,
        documentos: false,
        administrativo: false,
      },
      dotEnv: {
        isAmbientaly: env.isAmbientaly,
      },
    };
  },
  mounted() {
    this.getPendingInvoices();
    // Fechar dropdown ao clicar fora
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuActive = !this.mobileMenuActive;
      // Adicionar/remover classe para evitar scroll do body quando menu está aberto
      if (this.mobileMenuActive) {
        document.body.classList.add('mobile-menu-open');
      } else {
        document.body.classList.remove('mobile-menu-open');
      }
    },
    
    closeMobileMenu() {
      this.mobileMenuActive = false;
      document.body.classList.remove('mobile-menu-open');
    },
    
    async changeCompany(userCompany) {
      await this.$store.dispatch('changeUserCompany', userCompany);
    },
    
    async changeCompanyMobile(userCompany) {
      await this.$store.dispatch('changeUserCompany', userCompany);
      this.closeMobileMenu();
    },
    
    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
    },
    
    handleClickOutside(event) {
      if (!event.target.closest('.notification-wrapper')) {
        this.showNotifications = false;
      }
    },
    
    showInvoicesModal() {
      this.showInvoicesModalFlag = true;
      this.showNotifications = false;
    },
    
    showInvoicesModalMobile() {
      this.showInvoicesModalFlag = true;
      this.closeMobileMenu();
    },
    
    closeInvoicesModal() {
      this.showInvoicesModalFlag = false;
    },
    
    seeAllDebts() {
      this.closeInvoicesModal();
      this.$router.push("/admin/invoice-list");
    },
    
    logout() {
      this.$swal
        .fire({
          title: "Tem certeza que deseja sair?",
          text: "Esta operação não poderá ser desfeita.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.closeMobileMenu();
            this.$router.push("/login");
            this.$store.dispatch("logout");
          }
        });
    },
    
    async getPendingInvoices() {
      await this.$store.dispatch('fetchDashboardPendingInvoices');
      this.pendingInvoices = this.$store.getters.dashboardPendingInvoices;
      this.pendingInvoicesTotal = this.$store.getters.dashboardPendingInvoicesTotal;
      
      // Mostrar modal automaticamente se houver faturas pendentes
      if (this.pendingInvoices.length > 0) {
        const date = new Date().getDate();
        const lastDateShowedModal = localStorage.getItem('showed_invoice_modal');
        
        if (lastDateShowedModal != date) {
          localStorage.setItem('showed_invoice_modal', date);
          this.showInvoicesModalFlag = true;
        }
      }
    },
    
    toggleMobileSubmenu(submenu) {
      this.mobileSubmenus[submenu] = !this.mobileSubmenus[submenu];
    },
  },
};
</script>

<style scoped>
/* ================================
   VARIÁVEIS CSS
================================= */
:root {
  --primary-color: #3b82f6;
  --primary-dark: #2563eb;
  --secondary-color: #64748b;
  --accent-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --success-color: #22c55e;
  --dark-color: #1e293b;
  --light-color: #f8fafc;
  --border-color: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --border-radius: 8px;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ================================
   HEADER PRINCIPAL
================================= */
.header-v2 {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-bottom: 1px solid var(--border-color);
  box-shadow: var(--shadow-md);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 1000;
  backdrop-filter: blur(10px);
}

.header-container {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 24px;
  max-width: 100%;
}

/* ================================
   LOGO (ESQUERDA)
================================= */
.header-left {
  flex: 0 0 auto;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: var(--dark-color);
  font-weight: 700;
  font-size: 18px;
  transition: var(--transition);
}

.logo-link:hover {
  color: var(--primary-color);
}

.logo-image {
  width: 150px;
  /* height: 100px; */
  border-radius: 6px;
}

.logo-text {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.5px;
}

/* ================================
   SELETOR DE EMPRESA (CENTRO)
================================= */
.header-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 24px;
}

.company-selector {
  width: 100%;
  max-width: 500px;
}

.dropdown {
  position: relative;
  width: 100%;
}

.company-btn {
  //background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  border: none;
  border-radius: 12px;
  padding: 10px 16px;
  //color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  transition: var(--transition);
  box-shadow: var(--shadow-sm);
  font-weight: 500;
}

.company-btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.company-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.company-label {
  font-size: 11px;
  opacity: 0.8;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.company-name {
  font-size: 14px;
  font-weight: 600;
  margin-top: 2px;
}

.dropdown-arrow {
  transition: var(--transition);
  font-size: 12px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-lg);
  margin-top: 4px;
  padding: 8px 0;
  z-index: 1000;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  color: var(--dark-color);
  text-decoration: none;
  transition: var(--transition);
  font-size: 14px;
  gap: 10px;
}

.dropdown-item:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(16, 185, 129, 0.05) 100%);
  color: var(--primary-color);
}

.company-icon {
  color: var(--secondary-color);
  transition: var(--transition);
}

.dropdown-item:hover .company-icon {
  color: var(--primary-color);
}

/* ================================
   AÇÕES (DIREITA)
================================= */
.header-right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.maintenance-badge {
  background: var(--danger-color);
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* ================================
   NOTIFICAÇÕES
================================= */
.notification-wrapper {
  position: relative;
}

.notification-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--transition);
  color: var(--secondary-color);
  position: relative;
}

.notification-btn:hover {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
  transform: scale(1.05);
}

.notification-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: var(--danger-color);
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
}

.notifications-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-lg);
  margin-top: 8px;
  min-width: 320px;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.notifications-header {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  color: white;
  padding: 16px 20px;
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}

.notifications-header h6 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.notifications-content {
  max-height: 300px;
  overflow-y: auto;
}

.notifications-list {
  padding: 8px 0;
}

.notification-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  transition: var(--transition);
  border-bottom: 1px solid var(--border-color);
}

.notification-item:hover {
  background: rgba(59, 130, 246, 0.05);
  transform: translateX(2px);
}

.notification-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--danger-color) 0%, #ff6b6b 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  box-shadow: var(--shadow-sm);
}

.notification-details {
  flex: 1;
}

.notification-details h6 {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--dark-color);
}

.notification-details span {
  font-size: 13px;
  color: var(--secondary-color);
}

.notification-arrow {
  color: var(--secondary-color);
  font-size: 12px;
  transition: var(--transition);
}

.notification-item:hover .notification-arrow {
  color: var(--primary-color);
  transform: translateX(3px);
}

.no-notifications {
  text-align: center;
  padding: 40px 20px;
  color: var(--secondary-color);
}

.no-notifications p {
  margin: 8px 0 0 0;
  font-size: 14px;
}

/* ================================
   BOTÕES DE AÇÃO
================================= */
.action-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--transition);
  color: var(--secondary-color);
}

.action-btn:hover {
  transform: scale(1.05);
}

.logout-btn:hover {
  background: var(--danger-color);
  border-color: var(--danger-color);
  color: white;
}

/* ================================
   PERFIL DO USUÁRIO
================================= */
.profile-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  border-radius: 20px;
  text-decoration: none;
  color: var(--dark-color);
  transition: var(--transition);
  border: 1px solid transparent;
}

.profile-link:hover {
  background: rgba(59, 130, 246, 0.05);
  border-color: var(--border-color);
  color: var(--primary-color);
}

.profile-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid var(--border-color);
  transition: var(--transition);
}

.profile-link:hover .profile-avatar {
  border-color: var(--primary-color);
  transform: scale(1.05);
}

.profile-info {
  display: flex;
  flex-direction: column;
}

.profile-name {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}

/* ================================
   BOTÃO MOBILE
================================= */
.mobile-menu-btn {
  display: none;
  background: transparent;
  border: none;
  padding: 8px;
  margin-left: 12px;
  cursor: pointer;
  border-radius: 6px;
  width: 40px;
  height: 40px;
}

.hamburger-line {
  display: block;
  width: 24px;
  height: 2px;
  background: #334155;
  margin: 5px 0;
  border-radius: 1px;
  transition: all 0.3s ease;
}

/* ================================
   MENU MOBILE
================================= */
.mobile-menu {
  position: fixed;
  top: 0;
  right: -300px; /* Fora da tela inicialmente */
  width: 300px;
  height: 100vh;
  background: white;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.mobile-menu-active {
  right: 0; /* Visível na tela */
}

.mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: white;
}

.mobile-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid white;
}

.mobile-user-details {
  display: flex;
  flex-direction: column;
}

.mobile-user-name {
  font-weight: 600;
  font-size: 14px;
  color: white;
}

.mobile-profile-link {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

.mobile-close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.mobile-section-title {
  padding: 16px 16px 8px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mobile-company-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-company-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  border-bottom: 1px solid var(--border-color);
  color: var(--dark-color);
  font-size: 14px;
  position: relative;
}

.mobile-company-item:active {
  background: #f1f5f9;
}

.mobile-company-icon {
  color: var(--secondary-color);
}

.mobile-active-badge {
  position: absolute;
  right: 16px;
  background: var(--accent-color);
  color: white;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
}

.mobile-notifications {
  border-top: 1px solid var(--border-color);
  padding: 0 0 16px;
}

.mobile-notification-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--border-color);
}

.mobile-notification-item:active {
  background: #f1f5f9;
}

.mobile-notification-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, var(--danger-color) 0%, #ff6b6b 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-notification-details {
  flex: 1;
}

.mobile-notification-details h6 {
  margin: 0 0 2px 0;
  font-size: 14px;
  font-weight: 600;
}

.mobile-notification-details span {
  font-size: 12px;
  color: var(--secondary-color);
}

.mobile-notification-arrow {
  color: var(--secondary-color);
  font-size: 12px;
}

.mobile-actions {
  margin-top: auto; /* Empurra para o final do contêiner */
  border-top: 1px solid var(--border-color);
  padding: 16px;
}

.mobile-action-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  border: none;
  background: var(--danger-color);
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-action-btn:active {
  transform: translateY(1px);
  opacity: 0.9;
}

.mobile-action-icon {
  font-size: 16px;
}

/* Estilo para o overlay do menu mobile */
body.mobile-menu-open::after {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1999;
  backdrop-filter: blur(2px);
  animation: fadeIn 0.3s ease;
}

/* Desabilitar scroll do body quando menu está aberto */
body.mobile-menu-open {
  overflow: hidden;
}

/* ================================
   MODAL DE FATURAS
================================= */
.modal-overlay {
  position: fixed;
  top: 250px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  /* backdrop-filter: blur(5px); */
  animation: overlayFadeIn 0.3s ease;
}

@keyframes overlayFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background: white;
  border-radius: 16px;
  max-width: 600px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 100px;
  margin-bottom: auto;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
  animation: modalFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(-30px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 28px;
  border-bottom: 1px solid var(--border-color);
  background: #f8fafc;
}

.modal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--dark-color);
  display: flex;
  align-items: center;
  gap: 12px;
}

.close-btn {
  background: var(--danger-color);
  border: none;
  color: white;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.25);
}

.close-btn:hover {
  background: #dc2626;
  transform: scale(1.1);
}

.modal-body {
  padding: 24px 28px;
  max-height: 60vh;
  overflow-y: auto;
  background: white;
}

.invoices-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  overflow: hidden;
}

.invoices-table th,
.invoices-table td {
  padding: 16px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.invoices-table th {
  background: var(--primary-color);
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.invoices-table tr:last-child td {
  border-bottom: none;
}

.invoices-table tr:hover td {
  background-color: rgba(59, 130, 246, 0.05);
}

.invoices-table td {
  font-size: 15px;
  transition: all 0.2s ease;
}

.invoices-table td:nth-child(2) {
  font-weight: 600;
  color: var(--danger-color);
}

.invoices-table td:nth-child(3) {
  font-weight: 600;
  color: var(--warning-color);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

.btn-primary {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.25);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(59, 130, 246, 0.3);
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-icon {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.btn-primary:hover .btn-icon {
  transform: translateX(4px);
}

/* ================================
   RESPONSIVIDADE
================================= */
@media (max-width: 1024px) {
  .mobile-menu-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1999; /* Garantir que fique acima de outros elementos */
  }
  
  .header-center {
    display: none; /* Ocultar seletor de empresa no mobile */
  }
  
  .desktop-only {
    display: none !important; /* Ocultar elementos apenas desktop */
  }
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 16px;
  }
  
  .header-center {
    padding: 0 16px;
  }
  
  .company-selector {
    max-width: 320px;
  }
  
  .company-label {
    display: none;
  }
  
  .company-info {
    align-items: center;
  }
  
  .header-right {
    gap: 12px;
  }
  
  .profile-link {
    margin-left: 0;
  }
  
  .profile-info {
    display: none; /* Ocultar informações do perfil em telas pequenas */
  }
}

@media (max-width: 480px) {
  .header-center {
    padding: 0 12px;
  }
  
  .company-selector {
    max-width: 250px;
  }
  
  .company-btn {
    padding: 8px 12px;
    font-size: 13px;
  }
  
  .action-btn,
  .notification-btn {
    width: 36px;
    height: 36px;
  }
  
  .profile-avatar {
    width: 28px;
    height: 28px;
  }
  
  .header-right {
    gap: 8px;
  }
}

.mobile-main-menu {
  border-top: 1px solid var(--border-color);
  padding: 0 0 16px;
}

.mobile-menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  width: 100%;
  border-bottom: 1px solid var(--border-color);
  color: var(--dark-color);
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s ease;
}

.mobile-menu-item:active {
  background: #f1f5f9;
  color: var(--primary-color);
}

.mobile-menu-icon {
  color: var(--secondary-color);
  width: 20px;
}

.mobile-menu-item:active .mobile-menu-icon {
  color: var(--primary-color);
}

.mobile-menu-dropdown {
  margin-bottom: 8px;
}

.mobile-menu-dropdown-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  border-radius: 8px;
  color: var(--dark-color);
  transition: all 0.2s ease;
}

.mobile-menu-dropdown-header:active {
  background: rgba(59, 130, 246, 0.1);
}

.mobile-dropdown-arrow {
  margin-left: auto;
  color: var(--secondary-color);
  font-size: 12px;
  transition: all 0.2s ease;
}

.mobile-submenu {
  padding: 8px 0;
  margin: 4px 0 8px 20px;
  border-left: 2px solid var(--border-color);
}

.mobile-submenu-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  color: var(--secondary-color);
  text-decoration: none;
  transition: all 0.2s ease;
  font-size: 14px;
}

.mobile-submenu-item:active {
  color: var(--primary-color);
  transform: translateX(4px);
}

.mobile-submenu-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--secondary-color);
  margin-right: 12px;
  transition: all 0.2s ease;
}

.mobile-submenu-item:active .mobile-submenu-dot {
  background: var(--primary-color);
}

.mobile-novo-badge {
  background: linear-gradient(135deg, var(--danger-color) 0%, #ff6b6b 100%);
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 700;
  margin-left: auto;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
</style> 